import { ReactElement } from 'react';

import { Badge } from 'components/elements/badge/badge';
import { BadgeType } from 'components/elements/badge/types';
import IconChecked from 'components/icons/checked';
import IconCross from 'components/icons/cross';
import IconDash from 'components/icons/dash';
import IconRefresh from 'components/icons/refresh';

import { RefundStatus } from 'types/pwcOrder';

import { badgePropsMap } from './keys';
import { BadgeContent } from './styles';

interface StatusBadgeProps {
  status: RefundStatus | null;
}

const badgeToIconMap: Record<RefundStatus, ReactElement | null> = {
  [RefundStatus.AWAITING_FUNDS]: <IconRefresh />,
  [RefundStatus.INITIATED]: <IconRefresh />,
  [RefundStatus.PENDING]: <IconRefresh />,
  [RefundStatus.SUBMITTED]: <IconRefresh />,
  [RefundStatus.CONFIRMED]: <IconRefresh />,
  [RefundStatus.COMPLETED]: <IconChecked />,
  [RefundStatus.CANCELED]: <IconCross />,
  [RefundStatus.FAILED]: <IconCross />,
};

const badgeTypeMap: Record<RefundStatus, BadgeType> = {
  [RefundStatus.AWAITING_FUNDS]: BadgeType.Default,
  [RefundStatus.INITIATED]: BadgeType.Default,
  [RefundStatus.PENDING]: BadgeType.Default,
  [RefundStatus.SUBMITTED]: BadgeType.Default,
  [RefundStatus.CONFIRMED]: BadgeType.Default,
  [RefundStatus.COMPLETED]: BadgeType.Success,
  [RefundStatus.CANCELED]: BadgeType.Fail,
  [RefundStatus.FAILED]: BadgeType.Fail,
};

export const RefundStatusBadge = ({ status }: StatusBadgeProps) => {
  if (!status) {
    return <IconDash />;
  }

  const { type, label } = badgePropsMap[status];
  const icon = badgeToIconMap[type];
  const badgeType = badgeTypeMap[type];

  const usedLabel = label || <IconDash />;

  return (
    <Badge type={badgeType}>
      <BadgeContent>
        {icon}
        {usedLabel}
      </BadgeContent>
    </Badge>
  );
};
